// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"b14e9ec7","915":"4caa09c4"}[chunkId] + ".chunk.css";
};